import { test } from 'node:test';
test('ok', () => {});

function uncovered() {
  return 'uncovered';
}

